angular.module('Itao.IndicatorMap').directive('widgetAdderGroup', function (mapConfig) {
  'use strict';
  return {
    templateUrl: mapConfig.templateBasePath + 'widgetAdderGroup.html',
    restrict: 'E',
    scope: {
      numberOfIndicatorSets: '='
    },
    link: function(scope) {
      scope.showPriviligedWidgets = angular.copy(mapConfig.registeredUserMode);
      scope.$watch('numberOfIndicatorSets', function (numberOfIndicatorSets) {
        scope.showIndicatorSetCharts = numberOfIndicatorSets > 0;
      });
  }
  };
});
